const initialState = {
  detailLoading: false,
  specModalVisible: false,
  detail: {},
  detailTabActive: 0,
  spec: {},
  count: 1,

  commentList: [],
  commentTotal: 0,
  commentQuery: { page: 1, limit: 10 },
  skuItem: [],
};

function reducer(state, action) {
  switch (action.type) {
    case "setDetailLoading":
      return { ...state, detailLoading: action.payload };
    case "setSpec":
      return { ...state, spec: action.payload };
    case "setCount":
      return { ...state, count: action.payload };
    case "setDetail":
      return { ...state, detail: action.payload };
    case "setSpecModalVisible":
      return { ...state, specModalVisible: action.payload };
    case "setDetailTabActive":
      return { ...state, detailTabActive: action.payload };
    case "setCommentList":
      return { ...state, commentList: action.payload };
    case "setCommentTotal":
      return { ...state, commentTotal: action.payload };
    case "setCommentQuery":
      return { ...state, commentQuery: action.payload };
    case "setSeletSkuItem":
      return { ...state, skuItem: action.payload };
    default:
  }
}

const setDetailLoading = (payload) => ({
  type: "setDetailLoading",
  payload,
});

const setSpec = (payload) => ({
  type: "setSpec",
  payload,
});

const setCount = (payload) => ({
  type: "setCount",
  payload,
});

const setDetail = (payload) => ({
  type: "setDetail",
  payload,
});

const setSpecModalVisible = (payload) => ({
  type: "setSpecModalVisible",
  payload,
});

const setDetailTabActive = (payload) => ({
  type: "setDetailTabActive",
  payload,
});

const setCommentList = (payload) => ({
  type: "setCommentList",
  payload,
});

const setCommentTotal = (payload) => ({
  type: "setCommentTotal",
  payload,
});

const setCommentQuery = (payload) => ({
  type: "setCommentQuery",
  payload,
});

const setSeletSkuItem = (payload) => ({
  type: "setSeletSkuItem",
  payload,
});

export {
  initialState,
  reducer,
  setDetailLoading,
  setSpec,
  setCount,
  setDetail,
  setSpecModalVisible,
  setDetailTabActive,
  setCommentList,
  setCommentTotal,
  setCommentQuery,
  setSeletSkuItem
};
